export default __webpack_public_path__ + "static/Plots0022-c51090eead63105c094d3e8574ec2bd6.jpg";